import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import CiudadanosService from "../services/CiudadanosService";
import PageTitlesEstudios from "./PageTitlesEstudios";


const EstudiosSites = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [turnos, setTurnos] = useState([]);
    const [iframeURL, setIframeURL] = useState([]);
    const [errorMessage, setErrorMessage] = useState([]);


    const obtenerEstudios = (respCiudadano, respToken) => {
        var token = respToken.data.access_token;
        var datos = {
            documentType: "DNI",
            documentNumber: respCiudadano.data.DNI,
            birthDate: respCiudadano.data.FechaNacimiento.substring(0,10)
        }
        CiudadanosService.obtenerIframeEstudios(token, datos)
        .then((resp)=>{
            setIframeURL(resp.data.url);
            setLoading(false);
        })
        .catch((error)=>{
            console.log(error);
            setErrorMessage("No se encontraron estudios");
            setLoading(false);
        })
    }
    
    const obtenerTokenEstudios = (respCiudadano) => {
        CiudadanosService.obtenerTokenEstudios()
        .then((respToken)=>{
            obtenerEstudios(respCiudadano, respToken)
        })
        .catch((error)=>{
            console.log(error);
            setErrorMessage("Sin conexion para los estudios");
            setLoading(false);
        })

    }


    useEffect(()=> {
        setLoading(true);
        CiudadanosService.getDatosCiudadano(localStorage.getItem("hashLogin"))
        .then((respCiudadano)=>{
            obtenerTokenEstudios(respCiudadano)
        })
        .catch((error)=>{
            console.log("Error");
            setErrorMessage("Error no esperado");
            setLoading(false);}
        );
        },[]);

          return (
        
       
       <div class="container text-center mainContent" >
        <div style={{width:"100%", backgroundColor:"white", position: "absolute", zIndex:"100"}}>
        <PageTitlesEstudios texto="Mis Estudios"  icono="./icon_header_turnos.svg" retorno="/"/>
        </div>
{
    !loading?
    (iframeURL!=null && iframeURL!="")?
    
    <iframe src={iframeURL} class="upFrame frameContent" frameborder="0" scrolling="yes" ></iframe>

    :<div class="col miniTitleTop">{errorMessage}</div>:
    <div class="col miniTitleTop">Cargando...</div>
    
    
}

       </div>
        
        
          )     

    
    }
export default EstudiosSites;